<template>
  <div class="dashboard-box">
    <div class="dashboard-header">
      <ToggleButton :toggle="menuShow" class="toggle-button" @click="onToggle"></ToggleButton>
      <el-breadcrumb>
        <el-breadcrumb-item v-for="item, index in breadcumbList" :key="index">
          {{ item.meta.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>

      <DashboardUser class="userinfo" :user="user"></DashboardUser>
    </div>

    <div class="dashboard-content">
      <div style="height:50px;background-color: blueviolet;"></div>
      <div style="height:calc(100% - 50px);">
        <router-view></router-view>
      </div>
    </div>

    <div class="dashboard-menu" :class="menuShow ? 'show' : ''">
      <DashboardMenu :menu="menu" @onMenuItemClick="onMenuItemClick" :isShow="menuShow" />
    </div>

    <div class="dashboard-mask" v-show="menuShow" @click="menuShow = false"></div>

  </div>

</template>

<script>

import ToggleButton from '@/components/ToggleButton.vue'
import DashboardUser from './Dashboard/DashboardUser.vue'
import DashboardMenu from './Dashboard/DashboardMenu.vue'

export default {
  name: 'Dashboard',
  components: {
    ToggleButton,
    DashboardUser,
    DashboardMenu
  },
  data() {
    return {
      menuShow: false,
      user: null,
      menu: null,
      breadcumbList: []
    }
  },
  methods: {
    /**
     * 
     */
    onToggle() {
      this.menuShow = !this.menuShow
    },
    /**
     * 菜单项点击
     * @param {菜单项} item 
     */
    onMenuItemClick(item) {
      const path = item.url
      console.log('菜单点击', path)
      this.$router.push({
        path: path
      }).catch((err) => {
        console.log(err)
      })
      this.menuShow = false
      this.getBreadcrumbList()
    },
    /**
     * 获取面包屑导航
     */
    getBreadcrumbList() {
      //获取当前路由
      const matched = this.$route.matched
      console.log('当前路由导航>>', this.$route, matched)
      this.breadcumbList = matched
    }
  },
  mounted() {
    this.user = JSON.parse(window.localStorage.getItem('user'))
    this.menu = JSON.parse(window.localStorage.getItem('menu'))
    this.getBreadcrumbList()
  },
  watch: {
    $route(e) {
      this.getBreadcrumbList()
      console.log(e);
    }
  }
}
</script>

<style scoped lang="less">
.dashboard-box {
  width: 100%;
  height: 100%;
  min-width: 900px;
  position: relative;

  .toggle-button {
    margin: 0 15px;
  }

  .dashboard-header {
    height: 50px;
    background-color: #fff;
    position: fixed;
    top: 0px;
    right: 0px;
    left: 0px;
    z-index: 999;
    box-shadow: 0 2px 4px 0 var(--cb-color-shadow, rgba(0, 0, 0, 0.16));
    display: flex;
    align-items: center;


    .userinfo {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }

  .dashboard-content {
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.16);
  }

  .dashboard-menu {
    position: absolute;
    width: 250px;
    height: calc(100% - 50px);
    top: 50px;
    left: -250px;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 999;
    transition: left 0.35s;
    background-color: white;
  }

  .dashboard-menu.show {
    left: 0px;
  }
}

.dashboard-menu::-webkit-scrollbar {
  width: 0px;
}

.dashboard-mask {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.16);
  z-index: 900;
}
</style>
